import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.62868 3.67887C10.9944 2.44034 13.0058 2.44038 14.3714 3.67897L20.449 9.16579L20.4506 9.16729C21.2896 9.91799 21.75 11.0053 21.75 12.145V19.005C21.75 21.0761 20.0711 22.755 18 22.755H6C3.92893 22.755 2.25 21.0761 2.25 19.005V12.145C2.25 11.0052 2.71045 9.91782 3.54955 9.16711L9.6279 3.67958L9.62868 3.67887ZM10.6359 4.79042C11.43 4.06986 12.57 4.06986 13.3641 4.79042L13.3655 4.79169L19.4466 10.2817L19.4494 10.2842C19.9521 10.7335 20.25 11.4055 20.25 12.145V19.005C20.25 20.2476 19.2426 21.255 18 21.255H15.75V16.5C15.75 14.9812 14.5188 13.75 13 13.75H11C9.48122 13.75 8.25 14.9812 8.25 16.5V21.255H6C4.75736 21.255 3.75 20.2476 3.75 19.005V12.145C3.75 11.4055 4.04793 10.7335 4.5506 10.2842L10.6345 4.79169L10.6359 4.79042ZM9.75 16.5C9.75 15.8096 10.3096 15.25 11 15.25H13C13.6904 15.25 14.25 15.8096 14.25 16.5V21.25H9.75V16.5Z",
		fill: "currentColor"
	})
});
export { SvgIconHome as ReactComponent };
